document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open);
  }
  const searchToggle = event.target.closest('[data-search-toggle]');
  if (searchToggle) {
    const panel = document.querySelector('[data-search-panel]');
    panel.hidden = !panel.hidden;
    if (!panel.hidden) panel.querySelector('input').focus();
  }

  const submenuToggle = event.target.closest('[data-submenu-toggle]');
  if (submenuToggle) {
    const item = submenuToggle.closest('.nav-item');
    const willOpen = !item.classList.contains('is-open');
    document.querySelectorAll('.nav-item.is-open').forEach((openItem) => {
      openItem.classList.remove('is-open');
      openItem.querySelector('[data-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
    item.classList.toggle('is-open', willOpen);
    submenuToggle.setAttribute('aria-expanded', String(willOpen));
    event.stopPropagation();
  } else if (!event.target.closest('.nav-item')) {
    document.querySelectorAll('.nav-item.is-open').forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('[data-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.nav-item.is-open').forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('[data-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }

  const gallery = event.target.closest?.('[data-product-gallery]');
  if (gallery && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
    event.preventDefault();
    moveGallery(gallery, event.key === 'ArrowRight' ? 1 : -1);
  }
});

function showGallerySlide(gallery, index) {
  const slides = [...gallery.querySelectorAll('[data-product-slide]')];
  if (!slides.length) return;
  const nextIndex = (index + slides.length) % slides.length;
  slides.forEach((slide, i) => { slide.hidden = i !== nextIndex; });
  gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === nextIndex)));
  const status = gallery.querySelector('[data-gallery-status]');
  if (status) status.textContent = `${nextIndex + 1} / ${slides.length}`;
  gallery.dataset.currentSlide = String(nextIndex);
}

function moveGallery(gallery, direction) {
  showGallerySlide(gallery, Number(gallery.dataset.currentSlide || 0) + direction);
}

document.addEventListener('click', (event) => {
  const previous = event.target.closest('[data-gallery-prev]');
  const next = event.target.closest('[data-gallery-next]');
  const thumb = event.target.closest('[data-gallery-thumb]');
  const control = previous || next || thumb;
  if (!control) return;
  const gallery = control.closest('[data-product-gallery]');
  if (thumb) showGallerySlide(gallery, Number(thumb.dataset.galleryThumb));
  else moveGallery(gallery, next ? 1 : -1);
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const imageId = select.selectedOptions[0]?.dataset.imageId;
  if (!imageId) return;
  const gallery = document.querySelector('[data-product-gallery]');
  const slide = gallery?.querySelector(`[data-image-id="${imageId}"]`);
  if (slide) showGallerySlide(gallery, [...gallery.querySelectorAll('[data-product-slide]')].indexOf(slide));
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => showGallerySlide(gallery, 0));

document.addEventListener('shopify:section:load', () => window.scrollTo(0, window.scrollY));
